import { Input } from 'antd';
import styled, { css } from 'styled-components';

interface InputBoxStyleProps {
  width: string;
  height: string;
  transparent: boolean;
}

const sharedInputStyles = css<InputBoxStyleProps>`
  font-size: 14px;
  padding: 10px;
  border-radius: 5px;
  max-width: ${props => (props.width ? props.width : '100%')};
  height: ${props => (props.height ? props.height : '48px')};
  color: ${props =>
    props.transparent ? props.theme.colors.primary : props.theme.background.secondary};
  background: ${props => props.theme.background.inputs};
  border: 1px solid ${props => props.theme.background.inputsBorder};

  ::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }

  @media only screen and (max-width: 600px) {
    font-size: 17px;
  }

  /* Browsers paint autofill with a light background on the inner input only. */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active,
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px ${props => props.theme.background.inputs} inset !important;
    box-shadow: 0 0 0 1000px ${props => props.theme.background.inputs} inset !important;
    -webkit-text-fill-color: ${props => props.theme.colors.primary} !important;
    caret-color: ${props => props.theme.colors.primary};
    transition: background-color 5000s ease-in-out 0s;
  }
`;

const InputStyle = styled(Input)<InputBoxStyleProps>`
  ${sharedInputStyles}
`;

const PasswordInputStyle = styled(Input.Password)<InputBoxStyleProps>`
  ${sharedInputStyles}

  .ant-input {
    background: transparent;
    color: inherit;
  }

  .ant-input-password-icon {
    color: rgba(255, 255, 255, 0.65);

    &:hover {
      color: rgba(255, 255, 255, 0.95);
    }
  }
`;

export { InputStyle, PasswordInputStyle };
